import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';
import { timer } from 'rxjs';

let debounceTimer: any;

@Component({
  selector: 'app-add-opening',
  templateUrl: './add-opening.component.html',
  styleUrls: ['./add-opening.component.css']
})
export class AddOpeningComponent implements OnInit {

  form: FormGroup;
  message: string;
  authToken = localStorage.getItem('auth');
  passwordErr = "";
  messageErr = "";
  openingID: string = this.route.snapshot.params.id;
  businessID = this.route.snapshot.params.businessID;
  type = this.route.snapshot.params.type;
  show_mdtypes = [];
  companyGroups = [];
  mdGroups = [];
  subGroups = [];
  selectedSubtypes = [];
  wellfareAreas = [];
  selectedMDType;
  selectedMDSubtype;
  price = 0;
  pricing;
  selectedSubGroup;
  locationData = [];
  selectedLocation
  currentScreen = 1;
  showLogoErr = false;
  vat_amount = 0.00;
  locationDetails = false;
  isLoading = false;
  days_ad_amount = 0.00;
  total_sum = 0.00;
  users = [];
  currentUserId = this.authService.getTokenData().userID;
  charLen = 0;
  saved_users = [];
  invoice_details_filled = false;
  work_possibilities = [
    { id: 'full-time', name_fi: 'Vakituinen' },
    { id: 'fixed-term', name_fi: 'Määräaikainen' },
    { id: 'buy-service', name_fi: 'Keikka' },
    { id: 'service', name_fi: 'Virka' },
    { id: 'summer-job', name_fi: 'Kesätyö' },
    { id: 'self-employed', name_fi: 'Ammatinharjoittaja' },
    { id: 'trainee', name_fi: 'Harjoittelu' },
    { id: 'specialty', name_fi: 'Erikoistuminen' },
    { id: 'indenture', name_fi: 'Oppisopimus' },
    { id: 'negotiable', name_fi: 'Työsuhde sovittavissa' },
  ]

  student_types = [
    { id: 'trainee', name_fi: 'Harjoittelija' },
    { id: 'specialty', name_fi: 'Erikoistuva' },
  ]

  timing = [
    { id: 'full_time', name_fi: 'Kokoaikatyö' },
    { id: 'part_time', name_fi: 'Osa-aikatyö' },
    { id: '3_shift_work', name_fi: '3-vuorotyö' },
    { id: '2_shift_work', name_fi: '2-vuorotyö' },
    { id: 'hourly', name_fi: 'Tuntityö' },
    { id: 'negotiable', name_fi: 'Työaika sovittavissa' },
  ]

  tele_types = [
    { id: 'no', name_fi: 'Ei' },
    { id: 'partly', name_fi: 'Osittain' },
    { id: 'yes', name_fi: 'Kyllä' },
  ]


  btnText;
  company;
  user = [];
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  get description() { return this.form.get('description') };
  get title() { return this.form.get('title') };
  get application_ends() { return this.form.get('application_ends') };
  get allow_marketplace() { return this.form.get('allow_marketplace') };
  get application_url() { return this.form.get('application_url') };
  get wage_min() { return this.form.get('wage_min') };
  get wage_max() { return this.form.get('wage_max') };
  get zip() { return this.form.get('zip') };
  get city() { return this.form.get('city') };
  get address() { return this.form.get('address') };
  get remote_possibility() { return this.form.get('remote_possibility') };
  get youtubeLink() { return this.form.get('youtubeLink') };
  get keywords() { return this.form.get('keywords') };


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.fetchMDParams();
    this.fetchSubgroups();
    this.fetchFormedPrices();
    this.fetchWellfareAreas();
    this.getBusinessDetails();
    if (!this.openingID) {
      this.getUsers({});
    }

    this.form = this.fb.group({


      description: ['', Validators.required],
      wage_min: [''],
      title: [''],
      wage_max: [''],
      remote_possibility: ['',],
      application_ends: ['', Validators.required],
      youtubeLink: [''],
      city: ['',],
      address: ['',],
      zip: ['',],
      keywords: [''],
      application_url: [''],


    });

    if (this.openingID) {
      this.btnText = "Tallenna muutokset"
      this.fetchOpeningData();
    }
    else {
      this.btnText = "Lisää työpaikka"
    }

  }

  fetchWellfareAreas() {

    //test if wellfare areas are stored in web storage
    if (localStorage.getItem('wellfareAreas')) {
      this.wellfareAreas = JSON.parse(localStorage.getItem('wellfareAreas'));
      //Add to first element 
      return;
    }
    else {

      this.http.get(environment.PARAMS_WELLFAREAREAS, this.httpOptions).subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.wellfareAreas = res.message['wellfare-areas'];
            //Store wellfare areas to web storage
            localStorage.setItem('wellfareAreas', JSON.stringify(this.wellfareAreas));


          }
          else {
            this.wellfareAreas = []
          }

        }, (err: any) => {

        }
      )
    }
  }

  nextScreen() {
    this.currentScreen = this.currentScreen + 1;
  }

  countChars() {
    var title = this.form.value.keywords;
    this.charLen = title.length;

  }

  getUsers(data) {

    this.http.get(environment.USERS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {

          var nusers = res.message;
          for (let i = 0; i < nusers.length; i++) {
            var user = nusers[i];
            if (user._id == this.currentUserId) {
              nusers[i].mainUser = true;
              break;
            }
          }

          if (this.openingID) {
            if (data.notification_recipients && data.notification_recipients.length > 0) {
              for (let i = 0; i < nusers.length; i++) {
                const user = nusers[i];
                for (let j = 0; j < data.notification_recipients.length; j++) {
                  const not = data.notification_recipients[j];
                  if (user._id == not) {
                    nusers[i].selected = true;
                    //check the checkbox
                    setTimeout(() => {
                      (<HTMLInputElement>document.getElementById('user_' + user._id)).checked = true;
                    }, 200)
                    this.saved_users.push(user);
                  }
                }
              }
            }

          }


          //set mainuser to first
          var mainUser = res.message.find(x => x.mainUser);
          var index = res.message.indexOf(mainUser);
          if (index != -1) {
            res.message.splice(index, 1);
            res.message.unshift(mainUser);
          }

          this.users = res.message;

        }
        else {
          var anElm = document.getElementById('notadded');
          anElm.style.display = "block";
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  getBusinessDetails() {

    this.http.get(environment.USER_BUSINESS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.company = res.message[0];

          if (this.company) {
            if (this.company.vatID && this.company.vatID != "") {
              if (this.company.einvoiceaddress && this.company.einvoiceaddress != "") {
                this.invoice_details_filled = true;
              }
            }
          }

          if (!this.company.logo) {
            this.showLogoErr = true;
          }
        }
        else {
          var anElm = document.getElementById('notadded');
          anElm.style.display = "block";
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })


  }

  fetchMDParams() {
    this.http.get(environment.PARAMS_MD_TYPES, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.mdGroups = res.message['md-types'];

        }
        else {
          var anElm = document.getElementById('notadded');
          anElm.style.display = "block";
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }


  fetchFormedPrices() {
    this.http.get(environment.EMPLOYER_PRICING, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.pricing = res.message;


        }
        else {

        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  fetchSubgroups() {
    this.http.get(environment.SUBGROUPS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {

          //Sort res.message alphabetically
          if (res.message && res.message.length > 0) {
            res.message.sort((a, b) => {
              if (a.businessName < b.businessName) { return -1; }
              if (a.businessName > b.businessName) { return 1; }
              return 0;
            });

          }

          this.subGroups = res.message;

        }
        else {
          var anElm = document.getElementById('notadded');
          anElm.style.display = "block";
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  subGroupSelected(e) {
    //get the value of selected option
    var mdid = e.target.id;
    var subgroup = (<HTMLInputElement>document.getElementById(mdid)).value;

    for (let i = 0; i < this.subGroups.length; i++) {
      const group = this.subGroups[i];

      if (group._id == subgroup) {
        this.selectedSubGroup = group;
        break;
      }

    }
  }

  selectSubtype() {
    var elm = (<HTMLInputElement>document.getElementById('md-sub-type')).value;
    for (let i = 0; i < this.selectedSubtypes.length; i++) {
      const el = this.selectedSubtypes[i];

      if (el.id == elm) {
        this.selectedMDSubtype = el;
        break;
      }

    }
  }


  fetchOpeningData() {
    this.http.get(environment.OPENING + '/' + this.openingID, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          var opening = res.message;
          this.getUsers(opening);

          //Now set the values
          this.form.controls['description'].setValue(opening.description_fi);
          this.form.controls['application_ends'].setValue(new Date(opening.application_ends).toISOString().substring(0, 10));
          this.form.controls['city'].setValue(opening.location.city);
          this.form.controls['address'].setValue(opening.location.address);
          this.form.controls['zip'].setValue(opening.location.zip);
          this.form.controls['remote_possibility'].setValue(opening.remote_possibility);
          if (opening.youtubeLink) {
            var link = 'https://youtu.be/' + opening.youtubeLink;
          }
          else {
            var link = "";
          }
          this.form.controls['youtubeLink'].setValue(link);
          this.form.controls['keywords'].setValue(opening.keywords);
          if(opening.application_version == 2){
            this.form.controls['title'].setValue(opening?.title ? opening.title : '');
            this.form.controls['wage_min'].setValue(opening?.wage_min ? opening.wage_min : '');
            this.form.controls['wage_max'].setValue(opening?.wage_max ? opening.wage_max : '');
            //wage type
            if(opening.wage_type == 'monthly') {
              (<HTMLInputElement>document.getElementById('monthlywage')).checked = true;
            }
            else {
              (<HTMLInputElement>document.getElementById('hourlywage')).checked = true;
            }

            //Md type
            setTimeout(() => {

              this.selectedMDType = opening.job_title;
              console.log(this.selectedMDType);

              (<HTMLInputElement>document.getElementById('md-type-search')).value = this.selectedMDType.name_fi
            }, 300)

            //External application url
            this.form.controls['application_url'].setValue(opening.ext_application_url);
            //Check checkbox
            if(opening.ext_application_url) {
              (<HTMLInputElement>document.getElementById('fCheckURL')).checked = true;
              //uncheck the other
              (<HTMLInputElement>document.getElementById('fCheckRekruuApplication')).checked = false;
            }
          }
          else{

            setTimeout(() => {

              this.selectedMDType = opening.mdType;
              (<HTMLInputElement>document.getElementById('md-type-search')).value = this.selectedMDType.name_fi
  
              for (let i = 0; i < this.mdGroups.length; i++) {
                const elm = this.mdGroups[i];
  
                if (elm.sys_id == opening.mdType.sys_id) {
                  this.selectedMDType = elm;
  
                }
  
              }}, 300)
            
          }
          
        
          //student type


          if (opening.keywords) {
            this.charLen = opening.keywords.length;
          }


          //select subgroup



            setTimeout(() => {

              //Check wokk type
              for (let j = 0; j < this.work_possibilities.length; j++) {
                const wp = this.work_possibilities[j];

                if (wp.id == opening.work_type) {
                  (<HTMLSelectElement>document.getElementById('work_type_select')).value = wp.id;
                  break;
                }
              }

              //Lets check timing
              for (let i = 0; i < this.timing.length; i++) {
                const timing = this.timing[i];

                if (timing.id == opening.timing) {
                  (<HTMLInputElement>document.getElementById('timing')).value = timing.id;
                  break;
                }
              }

            }, 100)
  

        }
        else {
          console.log('buu')

        }

      }, (err: any) => {

      }
    )
  }

  onSubmit() {



    if (this.charLen > 70) {
      alert('Avainsanat saavat olla enintään 70 merkkiä pitkiä');
      this.isLoading = false;
      return;
    }


    if (this.openingID) {
      this.editOpening();
    }
    else {

      var check = (<HTMLInputElement>document.getElementById('no_use_subgroup')).checked;
      if (check == true) {


        var data = {
          city: this.form.value.city,
          address: this.form.value.address,
          zip: this.form.value.zip,
        }


        if (data.city.length > 0 && !data.address && !data.zip) {
          this.fetchLocationData();
          return;

        }
        else if (!data.city || !data.address || !data.zip) {
          var not_specified = (<HTMLSelectElement>document.getElementById('not_spesific_location')).value;

          var wf_obj;

          for (let i = 0; i < this.wellfareAreas.length; i++) {
            const wf = this.wellfareAreas[i];

            if (wf.id == not_specified) {
              wf_obj = wf;
              break;
            }
          }

          if (!wf_obj || !wf_obj.name_fi) {
            alert('Tarkista lokaation tiedot');
            this.isLoading = false;
            return;
          }

          var location_obj = {
            city: wf_obj.name_fi,
            address: "",
            zip: "",
            wellFareAreaID: wf_obj.id,
          }

          this.selectedLocation = location_obj;
          this.addOpening();


        }
        else {

          this.fetchLocationData();
          return;

        }
      }
      else {
        if (!this.selectedSubGroup) {
          alert('Valitse lokaatio');
          this.isLoading = false;
          return;
        }
        else {
          if (!this.selectedSubGroup.location) {
            alert('Valitse työpaikan sijainti');
            this.isLoading = false;
            return;
          }
          else {
            this.selectedLocation = this.selectedSubGroup.location;
            this.addOpening();
            this.isLoading = true;
          }


        }
      }
    }


  }

  editOpening() {

    //check if any is empty
    if (this.form.value.description == "" || this.form.value.description == null) {
      this.isLoading = false;
      alert("Lisää kuvaus")

      return;
    }


    var selected_type = "";

    //check if work type is selected
    var wt_elm = (<HTMLInputElement>document.getElementById('work_type_select')).value;
    if (wt_elm == "" || wt_elm == null) {
      this.isLoading = false;
      alert("Valitse työsuhde");

      return;
    }
    else {
      for (let i = 0; i < this.work_possibilities.length; i++) {
        const element = this.work_possibilities[i];

        if (element.id == wt_elm) {
          selected_type = element.id;
          break;
        }

      }
    }

    //Check timing

    //Check if timing is selected
    var timing_elm = (<HTMLInputElement>document.getElementById('timing')).value;
    if (timing_elm == "" || timing_elm == null) {
      this.isLoading = false;
      alert("Valitse työaika")
      return;
    }

    for (let i = 0; i < this.timing.length; i++) {
      const timing = this.timing[i];

      var elm = (<HTMLInputElement>document.getElementById('timing')).value;

      if (timing.id == elm) {
        var selected_timing = timing.id;
        break;
      }

    }


    //Check if application ends is max 30 days
    var app_ends = new Date(this.form.value.application_ends).getTime();
    var today = new Date().getTime();
    var diff = app_ends - today;
    var days = diff / (1000 * 3600 * 24);

    //Check if application ends is in the past
    if (app_ends < today) {
      alert("Hakuaika ei voi olla menneisyydessä");
      return;
    }

    //if no remote possibility
    if (!this.form.value.remote_possibility) {
      alert('Valitse etätyömahdollisuus');
    }


    var notification_recipients = [];

    if (this.saved_users.length > 0) {
      for (let i = 0; i < this.saved_users.length; i++) {
        const user = this.saved_users[i];
        notification_recipients.push(user._id);
      }
    }


    var mdType = this.selectedMDType;

    var req = {
      title: this.form.value.title,
      description: this.form.value.description,
      application_ends: this.form.value.application_ends,
      work_type: selected_type,
      wage_min: this.form.value.wage_min,
      wage_max: this.form.value.wage_max,
      job_title: mdType,
      timing: selected_timing,
      businessID: this.businessID,
      openingID: this.openingID,
      remote_possibility: this.form.value.remote_possibility,
      type: this.type,
      student_type: "no",
      keywords: this.form.value.keywords,
      notification_recipients: notification_recipients,
      ext_application_url: this.form.value.application_url ? this.form.value.application_url : "",
      application_version: 2,

    }


    this.http.put(environment.OPENING, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.router.navigate(['/' + this.businessID + '/openings/single-opening/' + this.openingID])
          return;
        }
        else {
          alert('Työpaikan muokkaaminen epäonnistui');
          return;
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })


  }

  closeLoading() {
    setTimeout(() => {
      this.isLoading = false;
    }, 500)
  }

  addOpening() {


    this.isLoading = true;
    //check if any is empty
    if (this.form.value.description == "" || this.form.value.description == null) {
      this.closeLoading();
      alert("Lisää kuvaus")

      return;
    }

    //Check if title is empty
    if (this.form.value.title == "" || this.form.value.title == null) {
      this.closeLoading();
      alert("Lisää otsikko")

      return;
    }

    var monthly_wage_selected = (<HTMLInputElement>document.getElementById('monthlywage')).checked;

    var wage_type = monthly_wage_selected ? 'monthly' : 'hourly';

    var selected_type = "";
    //check if work type is selected
    var selected_type = (<HTMLInputElement>document.getElementById('work_type_select')).value;
    if (selected_type == "" || selected_type == null) {
      this.closeLoading();
      alert("Valitse työsuhde");

      return;
    }



    //if no remote possibility
    if (!this.form.value.remote_possibility) {
      this.closeLoading();
      alert('Valitse etätyömahdollisuus');

      return;
    }

    //Check if timing is selected
    var timing_elm = (<HTMLInputElement>document.getElementById('timing')).value;
    if (timing_elm == "" || timing_elm == null) {
      this.closeLoading();
      alert("Valitse työaika")
      return;
    }

    for (let i = 0; i < this.timing.length; i++) {
      const timing = this.timing[i];

      var elm = (<HTMLInputElement>document.getElementById('timing')).value;

      if (timing.id == elm) {
        var selected_timing = timing.id;
        break;
      }

    }

    //Check if application ends is max 30 days
    var app_ends = new Date(this.form.value.application_ends).getTime();
    var today = new Date().getTime();
    var diff = app_ends - today;
    var days = diff / (1000 * 3600 * 24);

    //Check if application ends is in the past
    if (app_ends < today) {
      alert("Hakuaika ei voi olla menneisyydessä");
      this.closeLoading();
      return;
    }

    if (!this.selectedLocation) {
      //take location details from subgroup
      this.selectedLocation = {
        city: this.selectedSubGroup.city,
        address: this.selectedSubGroup.address,
        zip: this.selectedSubGroup.zip,
        coordinates: [this.selectedSubGroup.lat, this.selectedSubGroup.lon],
        wellFareAreaID: this.selectedSubGroup.wellfareArea.id,
      }
    }




    var notification_recipients = [];

    if (this.saved_users.length > 0) {
      for (let i = 0; i < this.saved_users.length; i++) {
        const user = this.saved_users[i];
        notification_recipients.push(user._id);
      }
    }

    if (<HTMLInputElement>document.getElementById('campaign')) {
      var camp_days = isNaN(parseInt((<HTMLInputElement>document.getElementById('campaign')).value)) ? 0 : parseInt((<HTMLInputElement>document.getElementById('campaign')).value)
    }
    else {
      var camp_days = 0;
    }

    if (<HTMLInputElement>document.getElementById('cost_center')) {
      var cost_center = !(<HTMLInputElement>document.getElementById('cost_center')).value ? '' : (<HTMLInputElement>document.getElementById('cost_center')).value
    }
    else {
      var cost_center = '';
    }

    var has_user_selected_ext_url = (<HTMLInputElement>document.getElementById('fCheckURL')).checked;

    if(has_user_selected_ext_url) {
      if(!this.form.value.application_url) {
        alert('Lisää ulkoinen hakulinkki');
        this.closeLoading();
        return;
      }
    }

    //Check if selectedMDType is empty
    if (!this.selectedMDType) {
      this.closeLoading();
      alert('Lisää työpaikan titteli');
      return;
    }



    var req = {
      title: this.form.value.title,
      description: this.form.value.description,
      type: this.type,
      application_ends: this.form.value.application_ends,
      work_type: selected_type,
      subGroup: this.selectedSubGroup,
      wage_type: wage_type,
      wage_min: this.form.value.wage_min,
      wage_max: this.form.value.wage_max,
      job_title: this.selectedMDType,
      timing: selected_timing,
      businessID: this.businessID,
      remote_possibility: this.form.value.remote_possibility,
      campaign_days: camp_days,
      public_leaver: this.company.public_leaver ? this.company.public_leaver : false,
      logo: this.company.logo,
      location: this.selectedLocation,
      student_type: "no",
      keywords: this.form.value.keywords,
      notification_recipients: notification_recipients,
      cost_center: cost_center,
      ext_application_url: this.form.value.application_url ? this.form.value.application_url : "",
      application_version: 2,
    }

    console.log(req);


    this.http.post(environment.OPENING, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {

          console.log(res.message);
          this.router.navigate(['/' + this.businessID + '/openings/single-opening/' + res.data.id])
          return;
        }
        else {
          alert('Työpaikan lisäämienn epäonnistui');
          this.isLoading = false;
          return;
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }


  handleTiming(data) {
    var elm = (<HTMLInputElement>document.getElementById('timing_' + data.id)).checked;
    for (let i = 0; i < this.timing.length; i++) {
      const wp = this.timing[i];

      if (wp.id != data.id) {
        (<HTMLInputElement>document.getElementById('timing_' + wp.id)).checked = false;
      }

    }
  }

  getInfo() {
    document.getElementById('feed-package').click();
  }

  updatePrice() {
    var camp_value = parseInt((<HTMLInputElement>document.getElementById('campaign')).value);
    console.log(camp_value);

    //If campaign value is not a number clear the input
    if (isNaN(camp_value)) {
      (<HTMLInputElement>document.getElementById('campaign')).value = "";
      camp_value = 0;
      this.total_sum = 0.00;
      this.price = 0.00;
      this.vat_amount = 0.00;
      this.days_ad_amount = 0.00;
      this.days_ad_amount = 0;
      return;
    }

    else if (camp_value && camp_value > 0) {

      var feed_ad_price = this.pricing.feed.ads.price;
      console.log(this.pricing, 'pricing');
      this.price = feed_ad_price * camp_value;
      this.vat_amount = (this.price * this.pricing.vat) - this.price;
      this.days_ad_amount = camp_value;
      this.total_sum = this.price + this.vat_amount;
      //to two decimals
      this.total_sum = Math.round(this.total_sum * 100) / 100;


    }
    else {
      if (camp_value <= 0) {
        alert("Kampanjan arvon tulee olla positiivinen");
      }
    }
  }

  fetchLocationData() {

    this.isLoading = true;

    var req = {
      city: this.form.value.city,
      address: this.form.value.address,
      zip: this.form.value.zip,
    }

    this.http.post(environment.GET_LOCATION_DATA, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.isLoading = false;

          var location_data = res.message;

          if (location_data.length > 0) {
            if (location_data.length == 1) {
              var data = location_data[0];
              var address = data.address;
              var lat = parseFloat(data.lat);
              var lon = parseFloat(data.lon);


              var coordinates = [lat, lon];

              Object.assign(address, { coordinates: coordinates });
              this.selectedLocation = address
              //if contains town replace the key with name city
              if (address.town) {
                address.city = address.town;
                delete address.town;
              }
              this.addOpening();
            }
            else {
              this.locationData = location_data;
              document.getElementById('location-modal').click();
            }
          }
          else {
            this.isLoading = false;
            alert('Sijaintia ei löytynyt, kokeile toista sijaintia');
          }


        }
        else {
          this.isLoading = false;
          alert('Sijaintia ei löytynyt, kokeile toista sijaintia. Voit kokeilla poistaa talonnumeron tai poistaa postinumeron ja osoitteen, jolloin järjestelmä käyttää pelkkää paikkakuntaa.');
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })

  }

  displayLocationDetails() {
    console.log('clicked')
    var check = (<HTMLInputElement>document.getElementById('no_use_subgroup')).checked;

    console.log(check)
    if (check == true) {
      document.getElementById('location-details').style.display = "block";
      this.locationDetails = true;
    }
    else {
      document.getElementById('location-details').style.display = "none";
      this.locationDetails = false;
    }

  }

  selectLocation(data) {
    var address = data.address;
    var lat = parseFloat(data.lat);
    var lon = parseFloat(data.lon);

    var coordinates = [lat, lon];

    Object.assign(address, {
      city: address.city ? address['city'] : address['town'],
      wellfareAreaID: address['ISO3166-2-lvl6'],
    });

    Object.assign(address, { coordinates: coordinates });

    this.selectedLocation = address;

    document.getElementById('close-location-modal').click();
    console.log(this.selectedLocation)

    //if no subgroup is selected
    if (!this.selectedSubGroup) {
      this.selectedSubGroup = {
        city: address.city,
        address: address.address,
        zip: address.zip,
        wellfareArea: address.wellfareAreaID,
        lat: lat,
        lon: lon,
        businessName: this.company.businessName,
      }
    }

    this.addOpening();


  }

  goBack() {
    if (this.currentScreen == 2 && !this.openingID) {
      this.currentScreen = 1
    }
    else {
      window.history.back();

    }
  }

  /*   onSearchMdType(){
      var elm = (<HTMLInputElement>document.getElementById('md-type-search'));
      console.log(elm)
      var input = (<HTMLInputElement>document.getElementById('md-type-search')).value;
      console.log(input, this.mdGroups,elm)
      if(input.length < 2){
        this.show_mdtypes = [];
        return;
      }
      else{
        //use el.name_fi or el.grouping_name_fi
        var search = input.toLowerCase();
        var result = this.mdGroups.filter(function (el) {
          //el.name_fi or el.grouping_name_fi
          return el.name_fi.toLowerCase().includes(search) || el.grouping_name_fi.toLowerCase().includes(search);
        });
        this.show_mdtypes = result;
        
        console.log(this.show_mdtypes)
      }
    } */

      onSearchMdType() {
        clearTimeout(debounceTimer); // Clear any existing timer to reset the debounce mechanism
      
        debounceTimer = setTimeout(() => {
          var elm = (<HTMLInputElement>document.getElementById('md-type-search'));
          var value = elm.value;
      
          this.http.get(environment.SEARCH_JOBTITLES + '?query=' + value + '&lang=fi', this.httpOptions).subscribe(
            (res: any) => {
              if (res.status == 200) {
                this.show_mdtypes = res.message;
                console.log(this.show_mdtypes);
              } else {
                console.log('ei ole kyseistä käyttäjää');
                this.show_mdtypes = [];
              }
            },
            (err: any) => {
              console.log('Error while finding status :: ', err);
            }
          );
        }, 500); // 1000ms = 1 second delay
      }

  mdtypeSelectedNew(data) {
    this.selectedMDType = data;
    //Set value to input and remove the list
    (<HTMLInputElement>document.getElementById('md-type-search')).value = data.name_fi;
    this.show_mdtypes = [];

  }

  openRecievers() {
    document.getElementById('users-modal').click()
  }

  /*   countChars(){
      var title = this.title.value;
      this.charLen = title.length;
  
    } */

  saveFavourites() {

    var selected_favourites = [];

    for (let i = 0; i < this.users.length; i++) {
      const elem = this.users[i];

      var check_elem = document.getElementById('user_' + elem._id) as HTMLInputElement;

      if (check_elem.checked) {
        selected_favourites.push(elem);
      }
    }

    this.saved_users = selected_favourites;
    console.log(this.saved_users)


  }

  checkOnlyOneChoise(groupClass: string, selectedId: string): void {
    const checkboxes = document.querySelectorAll(`.${groupClass}`);
    
    checkboxes.forEach((checkbox) => {
      const inputElement = checkbox as HTMLInputElement;
      if (inputElement.id !== selectedId) {
        inputElement.checked = false; // Uncheck all other checkboxes
      }
    });
  }



}
